import React, { Suspense } from 'react';
import { OUTBOUND_MANIFEST_TYPES } from '@/constants/manifestStatuses';

// Lazy for the same reason as the /Manifest header (ManifestGrid/configs/outbound.js): the selects reach
// App.js through useClientUser, and Manifests/constants.js is imported by plain unit tests.
const PickerSelect = React.lazy(() => import('../Manifest/PickerSelect'));
const StagingVerifierSelect = React.lazy(() => import('../Manifest/StagingVerifierSelect'));

const EMPTY = '—';

/**
 * Whether a manifest row gets a Picker select: any outbound-class manifest, same as the /Manifest header.
 * @param {{ type: string }} manifest
 * @returns {boolean}
 */
export const showsPicker = (manifest) => OUTBOUND_MANIFEST_TYPES.includes(manifest?.type);
/**
 * Whether a manifest row gets a Staging Verifier select: an OUTBOUND manifest whose route needs verification.
 * @param {{ type: string, route?: { needs_verification?: boolean } }} manifest
 * @returns {boolean}
 */
export const showsStagingVerifier = (manifest) =>
    manifest?.type === 'OUTBOUND' && !!manifest?.route?.needs_verification;

/**
 * Manifests table cell: the Picker select, or '—' when the row can't have a picker.
 * @param {{ row: { original: object }, callbacks?: { onAssignError?: Function } }} props
 */
export const PickerCell = ({ row, callbacks }) =>
    showsPicker(row.original) ? (
        <Suspense fallback={null}>
            <PickerSelect manifest={row.original} onError={callbacks?.onAssignError} />
        </Suspense>
    ) : (
        EMPTY
    );

/**
 * Manifests table cell: the Staging Verifier select, or '—' when the row's route doesn't need verification.
 * @param {{ row: { original: object }, callbacks?: { onAssignError?: Function } }} props
 */
export const StagingVerifierCell = ({ row, callbacks }) =>
    showsStagingVerifier(row.original) ? (
        <Suspense fallback={null}>
            <StagingVerifierSelect manifest={row.original} onError={callbacks?.onAssignError} />
        </Suspense>
    ) : (
        EMPTY
    );
